import React, {useMemo} from "react";
import "./orders.css";
import Page from "../../components/page/Page";
import SkeletonItem from "../../components/skeleton/SkeletonItem";
import {LineChart} from "../../components/charts/base/LineChart";
import useAppContext from "../../hooks/useAppContext";
import {getFriendlyDate} from "../../utils/friendlyDate";
import {CHART_COLORS} from "../../components/charts/consts/COLOR_SETS";
import OrdersTable from "./OrdersTable";
import {StackedChart} from "../../components/charts/base/StackedChart";

const Orders = () => {
    const { data: { lastDaysOrders } } = useAppContext();

    const labels = lastDaysOrders.data?.map((row: any) => getFriendlyDate(new Date(row.days)));
    const dataSets = [
        { label: 'Recovered', values: lastDaysOrders.data.map((ldm: any) => ldm.totalRecovered), backgroundColor: CHART_COLORS[2].transparent, borderColor: CHART_COLORS[2].transparent },
        { label: 'Orders', values: lastDaysOrders.data.map((ldm: any) => ldm.totalOrders), backgroundColor: CHART_COLORS[0].transparent, borderColor: CHART_COLORS[0].transparent },
    ];
    const isDataLoaded = useMemo(() => !!lastDaysOrders.data?.length, [lastDaysOrders.data?.length]);
    const totalOrders = lastDaysOrders.data.reduce((acc: number, row: any) => acc + parseInt(row.totalOrders), 0);
    const totalRecoveredOrders = lastDaysOrders.data.reduce((acc: number, row: any) => acc + parseInt(row.totalRecovered), 0);
    return (
        <Page
            className="orders-container"
            title="Orders"
            subtitle="A list of all orders that were done on this shop on selected dates"
        >
            <div className="orders-charts-layout">
                <div className="orders-charts-item grid-8">{lastDaysOrders.isLoading ? <SkeletonItem height={200} gridSpan={8} /> :
                    <StackedChart
                        labels={labels}
                        dataSets={dataSets}
                        data={lastDaysOrders.data}
                        isDataLoaded={isDataLoaded}
                    />
                }</div>
                <div className="orders-charts-item grid-4">
                    {lastDaysOrders.isLoading ? <SkeletonItem height={200} gridSpan={4} /> :
                        <div className="weekly-summary">
                            <div className="total-orders"><div>{totalOrders}</div><span>Orders <span>(Last 7 Days)</span></span></div>
                            <div className="total-converted"><div>{totalRecoveredOrders}</div><span>Recovered Orders <span>(Last 7 Days)</span></span></div>
                        </div>
                    }
                </div>
            </div>
            <OrdersTable />
        </Page>
    );
}

export default Orders;